module.exports = __webpack_public_path__ + "img/disc-c.77fd47c2.png";